import { render } from "./index.vue?vue&type=template&id=27c8970e&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=27c8970e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c8970e"],['__file',"resources/js/components/whatsapp-managment/includes/Profile/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c8970e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c8970e', __exports__)) {
    console.log('reload')
    api.reload('27c8970e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=27c8970e&scoped=true", () => {
    console.log('re-render')
    api.rerender('27c8970e', render)
  })

}


export default __exports__